import { render, staticRenderFns } from "./GenerateFormItem.vue?vue&type=template&id=4746917a&"
import script from "./GenerateFormItem.vue?vue&type=script&lang=js&"
export * from "./GenerateFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports